import { render } from "./Talentepool.vue?vue&type=template&id=0fe361b0"
import script from "./Talentepool.vue?vue&type=script&lang=ts"
export * from "./Talentepool.vue?vue&type=script&lang=ts"

import "./Talentepool.vue?vue&type=style&index=0&id=0fe361b0&lang=scss"
script.render = render

export default script